<template>
  <section class="section">
    <div class="container">
      <div class="columns is-centered">
        <div class="column is-one-third">
          <div class="box has-margin-top-xxl has-padding-lg">
            <div class="has-text-centered has-margin-bottom-lg">
              <img src="/static/img/logo-blue.svg" alt="" style="max-width: 75%">
            </div>

            <form action="">
              <div class="field">
                <label class="label">E-mail</label>
                <div class="control has-icons-left">
                  <input type="email" name="email" class="input" placeholder="Endereço de e-mail">
                  <span class="icon is-small is-left">
                    <i class="fas fa-user"></i>
                  </span>
                </div>
              </div>

              <div class="has-text-centered">
                <router-link :to="{ name: 'login' }" active-class="" class="button is-fullwidth is-danger has-margin-bottom-sm">
                  Solicitar redefinição de senha
                </router-link>
                <router-link :to="{ name: 'login' }"><small>fazer login</small></router-link>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ForgotPassword',
  metaInfo () {
    return { title: this.$t('title') }
  }
}
</script>

<i18n>
{
  "en-US": {
    "title": "Forgot my password"
  },
  "pt-BR": {
    "title": "Esqueci minha senha"
  }
}
</i18n>
